
import React from 'react';
import { 
  Coins, 
  FileText, 
  LineChart, 
  ShieldCheck, 
  Newspaper, 
  PersonStanding, 
  MessageSquareText, 
  Sparkles 
} from 'lucide-react';

const Benefits = () => {
  const journalistBenefits = [
    {
      icon: <Coins className="h-6 w-6 text-directpress-orange" />,
      title: "Direct Revenue Share",
      description: "Earn up to 90% of subscription revenue from your readers."
    },
    {
      icon: <FileText className="h-6 w-6 text-directpress-orange" />,
      title: "Content Ownership",
      description: "Maintain complete ownership of your journalistic work."
    },
    {
      icon: <LineChart className="h-6 w-6 text-directpress-orange" />,
      title: "Audience Insights",
      description: "Gain valuable data on how readers engage with your content."
    },
    {
      icon: <ShieldCheck className="h-6 w-6 text-directpress-orange" />,
      title: "Creative Freedom",
      description: "Publish what matters without editorial constraints."
    }
  ];

  const readerBenefits = [
    {
      icon: <Newspaper className="h-6 w-6 text-directpress-orange" />,
      title: "Personalized Feed",
      description: "Curate your news diet from journalists you trust."
    },
    {
      icon: <PersonStanding className="h-6 w-6 text-directpress-orange" />,
      title: "Support Journalists",
      description: "Directly fund the journalists whose work you value."
    },
    {
      icon: <MessageSquareText className="h-6 w-6 text-directpress-orange" />,
      title: "Direct Engagement",
      description: "Connect and interact with journalists directly."
    },
    {
      icon: <Sparkles className="h-6 w-6 text-directpress-orange" />,
      title: "AI Assistant",
      description: "Get personalized content recommendations and summaries."
    }
  ];

  return (
    <section id="features" className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-directpress-blue mb-4">Benefits</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            DirectPress creates value for both journalists and readers through innovative features.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Journalists Benefits */}
          <div>
            <div className="text-center md:text-left mb-8">
              <h3 className="text-2xl font-bold text-directpress-blue">For Journalists</h3>
              <p className="text-gray-600 mt-2">Tools and features that empower independent journalism.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {journalistBenefits.map((benefit, index) => (
                <div key={index} className="p-6 border border-gray-100 rounded-lg shadow-sm">
                  <div className="mb-4">{benefit.icon}</div>
                  <h4 className="text-lg font-semibold text-directpress-blue mb-2">{benefit.title}</h4>
                  <p className="text-gray-600 text-sm">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Readers Benefits */}
          <div>
            <div className="text-center md:text-left mb-8">
              <h3 className="text-2xl font-bold text-directpress-blue">For Readers</h3>
              <p className="text-gray-600 mt-2">A better way to consume and support quality journalism.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {readerBenefits.map((benefit, index) => (
                <div key={index} className="p-6 border border-gray-100 rounded-lg shadow-sm">
                  <div className="mb-4">{benefit.icon}</div>
                  <h4 className="text-lg font-semibold text-directpress-blue mb-2">{benefit.title}</h4>
                  <p className="text-gray-600 text-sm">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
